@for (dialog of dialogs(); track dialog.id) {
  <lib-confirm-dialog [dialog]="dialog" />
}
